module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "_idGenObjectStyleOverride-1"
  }, [_c('p', {
    staticClass: "titlepage_title"
  }, [_vm._v("Anonymous ")]), _vm._v(" "), _c('p', {
    staticClass: "titlepage_title2"
  }, [_vm._v("No More")]), _vm._v(" "), _c('p', {
    staticClass: "titlepage_subtitle"
  }, [_vm._v("ONE MOTHER’S FAITH-FILLED JOURNEY THROUGH ADDICTION, RECOVERY")]), _vm._v(" "), _c('p', {
    staticClass: "titlepage_subtitle2"
  }, [_vm._v("& REDEMPTION")]), _vm._v(" "), _c('p', {
    staticClass: "titlepage_author"
  }, [_vm._v("ALISA MASSEY")]), _vm._v(" "), _c('p', {
    staticClass: "titlepage_logo"
  }, [_c('img', {
    staticClass: "_idGenPageitem-1",
    attrs: {
      "alt": "MJ logo",
      "src": "image/MJ_icon_black.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("New York")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e12d25e8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/9781630472863_EPUB.vue
// module id = 60
// module chunks = 0